import { Button, Grid, IconButton, MenuItem, MenuList, Paper } from "@mui/material";
import React from "react";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import { smetaModals } from "../../Tools/modalManager";
import { escapeRegExp, formEdit } from "../../Tools/Tools";
import VirtualList from "../../Tools/VirtualList/VirtualList";

export default function DialogSetObjText(props) {
  // массив отсортированных записей
  const [sortRecords, setSortRecords] = React.useState([]);
  const [selected, setSelected] = React.useState({ id: null, text: null });

  // ссылка на контейнер с таблицей
  const tableContainer = React.useRef(null);
  // массив всех записей
  const records = React.useRef([]);

  const inputFilter = React.useRef();

  React.useEffect(() => {
    // получение jsx записей для таблицы
    records.current = props.list;
    // первичная отрисовка записей
    setSortRecords(records.current);
    // eslint-disable-next-line react-hooks/exhaustive-deps

    //Временный костыль
    // setTimeout(() => {
    //   tableContainer.current.querySelector("[tabIndex]").focus();
    // }, 300);
  }, []);

  // функиця на выбор записи из списка
  async function onEdit(item) {
    if (props.RequestID && item) {
      await formEdit("1", props.func, { Name: "Index", Value: item.id }, props.RequestID, props.from);
      smetaModals.close(props.smetaModalId);
      return;
    }
    if (props.onEdit && item) {
      let data = {};
      if (props.data) {
        data = { ...props.data };
      }
      props.onEdit({
        record: props.record,
        textchanged: "0",
        name: props.name,
        setValue: props.data ? props.data.setValue : undefined,
        setInputValue: props.data ? props.data.setInputValue : undefined,
        ...data,
        proof: false,
        value: item.text,
        tag: item.id,
        code: item.code,
        ...item,
        requestId: props.RequestID,
        CheckState: props.CheckState,
      });
      smetaModals.close(props.smetaModalId);
      return;
    }
  }

  // функция отсеивания записей по значению из поля ввода
  function filter(reg) {
    const regexp = new RegExp(escapeRegExp(reg).toLowerCase());
    setSortRecords(
      records.current.filter((item) => {
        if (item.text) {
          if (item.text.toLowerCase().match(regexp)) return item;
        }
        return false;
      }),
    );
  }
  return (
    <Grid
      container
      direction="column"
      justifyContent="flex-start"
      alignItems="flex-start"
      style={{ height: "100%", width: "100%" }}
    >
      {/* Таблица */}
      <Grid item style={{ width: "100%", height: "calc(100% - 40px)" }}>
        <Grid
          ref={tableContainer}
          style={{
            width: "100%",
            height: "100%",
            border: "1px solid #cccccc",
            overflow: "auto",
          }}
        >
          <MenuList
            tabIndex="-1"
            style={{
              height: "100%",
              width: "100%",
              outline: "none",
            }}
            onKeyDown={(ev) => {
              if (ev.code === "Enter") {
                onEdit();
              }
            }}
          >
            <VirtualList
              items={sortRecords}
              selected={selected}
              onKeyDown={(data, ev) => {
                if (ev.key === "Enter") {
                  onEdit(data);
                }
              }}
              onDoubleClick={(data) => {
                onEdit(data);
              }}
              onClick={(data) => {
                setSelected(data);
              }}
            />
          </MenuList>
        </Grid>
      </Grid>
      {/* Кнопки */}
      <Grid
        item
        style={{
          height: "40px",
          width: "100%",
          display: "flex",
          flexWrap: "nowrap",
        }}
      >
        <Grid container direction="row" justifyContent="flex-start" alignItems="center">
          {/* {Поиск} */}
          <Grid
            item
            style={{
              margin: "8px",
              width: "calc(100% - 182px)",
              display: "flex",
              flexWrap: "nowrap",
            }}
          >
            <IconButton
              onClick={() => {
                filter(inputFilter.current.value);
              }}
              style={{
                width: "27px",
                height: "27px",
                marginRight: "14px",
                marginLeft: "5px",
                display: "flex",
                flexWrap: "nowrap",
              }}
            >
              <SearchOutlinedIcon />
            </IconButton>
            <input
              ref={inputFilter}
              style={{
                width: "calc(100% - 46px)",
                outline: "0",
                display: "flex",
                flexWrap: "nowrap",
              }}
              // onBlur={(ev) => {
              //   filter(ev.target.value);
              // }}
              onKeyDown={(ev) => {
                if (ev.key === "Enter") {
                  filter(ev.target.value);
                }
              }}
              title="Filter"
            />
          </Grid>
          <Grid item style={{ width: "164px", display: "flex", flexWrap: "nowrap" }}>
            <Button
              size="small"
              variant="outlined"
              style={{ textTransform: "none", marginRight: "10px" }}
              value="1"
              className="button_Modal_Select"
              onClick={() => {
                onEdit(selected);
              }}
            >
              Выбрать
            </Button>
            <Button
              size="small"
              variant="outlined"
              style={{ textTransform: "none" }}
              value="2"
              className="button_Modal_Close"
              onClick={(ev) => {
                smetaModals.close(props.smetaModalId);
                if (props.onClose) {
                  props.onClose(ev);
                }
              }}
            >
              Отмена
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}
